/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const RewindMediumIcon = ({ width = 18, height = 21, color = '#fff', children, ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 18 21' fill={color} {...props} xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.35355 0.646447C3.54882 0.841709 3.54882 1.15829 3.35355 1.35355L1.70711 3H9C13.9706 3 18 7.02944 18 12C18 16.9706 13.9706 21 9 21C4.02944 21 1.49012e-08 16.9706 1.49012e-08 12C1.49012e-08 11.7239 0.223858 11.5 0.5 11.5C0.776142 11.5 1 11.7239 1 12C1 16.4183 4.58172 20 9 20C13.4183 20 17 16.4183 17 12C17 7.58172 13.4183 4 9 4H1.70711L3.35355 5.64645C3.54882 5.84171 3.54882 6.15829 3.35355 6.35355C3.15829 6.54882 2.84171 6.54882 2.64645 6.35355L0.146447 3.85355C-0.0488155 3.65829 -0.0488155 3.34171 0.146447 3.14645L2.64645 0.646447C2.84171 0.451184 3.15829 0.451184 3.35355 0.646447Z'
    />
    <text x='48%' y='58%' fontSize={9} dominantBaseline='middle' textAnchor='middle'>
      {children}
    </text>
  </svg>
);
export default RewindMediumIcon;
